export default __webpack_public_path__ + "static/media/cam-group-2.e3f12266.png";